// Module
var code = `<div class="candidate-profile-label" ng-if="candidateProfileCallForActionLabelCtrl.callForAction"> <div class="candidate-profile-label__title">{{'NEXT_ACTION_LABEL' | translate}}</div> <div class="candidate-profile-label__value">{{ candidateProfileCallForActionLabelCtrl.callForAction | translate}}</div> </div>`;
// Exports
export default code;